export interface InfluencerProduct {
  id: string;
  name: string;
  factory: string;
  factoryCountry: string;
  factoryFlag: string;
  category: string;
  image: string;
  retailPrice: number;
  commissionRate: number;
  commissionAmount: number;
  warehouseCountries: string[];
  totalSold: number;
  dropshipping: boolean;
  verified: boolean;
}

export interface StarProfile {
  id: string;
  name: string;
  platform: string;
  platformIcon: string;
  country: string;
  flag: string;
  followers: string;
  totalSales: number;
  totalCommission: number;
  avatar: string;
  niche: string;
}

export const influencerProducts: InfluencerProduct[] = [
  {
    id: "ip1",
    name: "Premium Oud & Frankincense Perfume Set",
    factory: "Muscat Frankincense & Oud Co.",
    factoryCountry: "Oman",
    factoryFlag: "🇴🇲",
    category: "Luxury Fragrance",
    image: "https://public.readdy.ai/ai/img_res/bfd7111e77e23e4e9739ccf07c8c586f.jpg",
    retailPrice: 89,
    commissionRate: 20,
    commissionAmount: 17.8,
    warehouseCountries: ["UAE", "Saudi Arabia", "UK", "USA", "Germany"],
    totalSold: 4820,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip2",
    name: "Dead Sea Mineral Skincare Gift Set",
    factory: "Dead Sea Cosmetics & Beauty Lab",
    factoryCountry: "Israel",
    factoryFlag: "🇮🇱",
    category: "Beauty & Skincare",
    image: "https://readdy.ai/api/search-image?query=Dead%20Sea%20mineral%20skincare%20gift%20set%20luxury%20beauty%20products%20white%20background%20product%20photography%20elegant%20premium%20Israel&width=400&height=400&seq=ip2&orientation=squarish",
    retailPrice: 120,
    commissionRate: 25,
    commissionAmount: 30,
    warehouseCountries: ["UAE", "USA", "UK", "Germany", "France"],
    totalSold: 3210,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip3",
    name: "Turkish Handcrafted Leather Bag",
    factory: "Izmir Leather & Accessories",
    factoryCountry: "Turkey",
    factoryFlag: "🇹🇷",
    category: "Fashion & Accessories",
    image: "https://readdy.ai/api/search-image?query=Turkish%20handcrafted%20leather%20bag%20luxury%20fashion%20white%20background%20product%20photography%20premium%20elegant%20Izmir%20Turkey&width=400&height=400&seq=ip3&orientation=squarish",
    retailPrice: 145,
    commissionRate: 22,
    commissionAmount: 31.9,
    warehouseCountries: ["UAE", "UK", "Germany", "Italy", "USA"],
    totalSold: 2890,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip4",
    name: "Sialkot FIFA Pro Football (Size 5)",
    factory: "Sialkot Sports & Leather Co.",
    factoryCountry: "Pakistan",
    factoryFlag: "🇵🇰",
    category: "Sports Equipment",
    image: "https://readdy.ai/api/search-image?query=FIFA%20pro%20football%20size%205%20premium%20sports%20equipment%20white%20background%20product%20photography%20professional%20Pakistan%20Sialkot&width=400&height=400&seq=ip4&orientation=squarish",
    retailPrice: 65,
    commissionRate: 18,
    commissionAmount: 11.7,
    warehouseCountries: ["UAE", "UK", "USA", "Australia", "Germany"],
    totalSold: 6540,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip5",
    name: "Smart Drip Irrigation Kit (Home Garden)",
    factory: "Tel Aviv AgriTech Solutions",
    factoryCountry: "Israel",
    factoryFlag: "🇮🇱",
    category: "AgriTech & Garden",
    image: "https://readdy.ai/api/search-image?query=smart%20drip%20irrigation%20kit%20home%20garden%20modern%20technology%20white%20background%20product%20photography%20professional%20Israel%20agritech&width=400&height=400&seq=ip5&orientation=squarish",
    retailPrice: 95,
    commissionRate: 20,
    commissionAmount: 19,
    warehouseCountries: ["UAE", "USA", "UK", "Australia", "Netherlands"],
    totalSold: 1980,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip6",
    name: "Authentic Gaziantep Baklava Gift Box 1kg",
    factory: "Gaziantep Spice & Food Export",
    factoryCountry: "Turkey",
    factoryFlag: "🇹🇷",
    category: "Food & Gourmet",
    image: "https://readdy.ai/api/search-image?query=authentic%20Gaziantep%20baklava%20gift%20box%201kg%20luxury%20gold%20packaging%20Turkish%20sweet%20white%20background%20product%20photography%20premium%20food&width=400&height=400&seq=ip6&orientation=squarish",
    retailPrice: 58,
    commissionRate: 20,
    commissionAmount: 11.6,
    warehouseCountries: ["UAE", "Saudi Arabia", "UK", "Germany", "USA"],
    totalSold: 8920,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip7",
    name: "Dubai Gold-Plated Luxury Watch",
    factory: "Dubai Luxury Timepieces",
    factoryCountry: "UAE",
    factoryFlag: "🇦🇪",
    category: "Luxury Watches",
    image: "https://readdy.ai/api/search-image?query=Dubai%20gold%20plated%20luxury%20watch%20elegant%20premium%20white%20background%20product%20photography%20professional%20UAE%20Middle%20East%20timepiece&width=400&height=400&seq=ip7&orientation=squarish",
    retailPrice: 380,
    commissionRate: 30,
    commissionAmount: 114,
    warehouseCountries: ["UAE", "Saudi Arabia", "UK", "USA", "Japan"],
    totalSold: 1240,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip8",
    name: "Galilee Extra Virgin Olive Oil 5L Premium",
    factory: "Galilee Organic Foods & Olive Oil",
    factoryCountry: "Israel",
    factoryFlag: "🇮🇱",
    category: "Organic Food",
    image: "https://readdy.ai/api/search-image?query=Galilee%20extra%20virgin%20olive%20oil%205L%20premium%20luxury%20bottle%20white%20background%20product%20photography%20professional%20food%20Israel%20Mediterranean&width=400&height=400&seq=ip8&orientation=squarish",
    retailPrice: 75,
    commissionRate: 18,
    commissionAmount: 13.5,
    warehouseCountries: ["UAE", "USA", "UK", "Germany", "France"],
    totalSold: 3450,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip9",
    name: "Bahrain Natural Pearl Jewellery Set",
    factory: "Bahrain Pearl Jewellery House",
    factoryCountry: "Bahrain",
    factoryFlag: "🇧🇭",
    category: "Luxury Jewellery",
    image: "https://readdy.ai/api/search-image?query=Bahrain%20natural%20pearl%20jewellery%20set%20luxury%20elegant%20white%20background%20product%20photography%20premium%20gold%20necklace%20earrings&width=400&height=400&seq=ip9&orientation=squarish",
    retailPrice: 420,
    commissionRate: 28,
    commissionAmount: 117.6,
    warehouseCountries: ["UAE", "Saudi Arabia", "UK", "USA", "Japan"],
    totalSold: 890,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip10",
    name: "Faisalabad Premium Cotton Bed Sheet Set",
    factory: "Faisalabad Textile Mills Ltd.",
    factoryCountry: "Pakistan",
    factoryFlag: "🇵🇰",
    category: "Home Textiles",
    image: "https://readdy.ai/api/search-image?query=premium%20cotton%20bed%20sheet%20set%20king%20size%20luxury%20white%20background%20product%20photography%20professional%20home%20textile%20Pakistan%20Faisalabad&width=400&height=400&seq=ip10&orientation=squarish",
    retailPrice: 85,
    commissionRate: 20,
    commissionAmount: 17,
    warehouseCountries: ["UAE", "UK", "USA", "Canada", "Australia"],
    totalSold: 5670,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip11",
    name: "Qatar Luxury Date Gift Box (Premium)",
    factory: "Qatar Dates & Luxury Foods",
    factoryCountry: "Qatar",
    factoryFlag: "🇶🇦",
    category: "Luxury Food",
    image: "https://readdy.ai/api/search-image?query=Qatar%20luxury%20date%20gift%20box%20premium%20elegant%20gold%20packaging%20Arabic%20dates%20white%20background%20product%20photography%20Middle%20East&width=400&height=400&seq=ip11&orientation=squarish",
    retailPrice: 68,
    commissionRate: 22,
    commissionAmount: 14.96,
    warehouseCountries: ["UAE", "Saudi Arabia", "UK", "USA", "Germany"],
    totalSold: 4120,
    dropshipping: true,
    verified: true,
  },
  {
    id: "ip12",
    name: "Istanbul Silk Scarf Collection (3pcs)",
    factory: "Bursa Silk & Luxury Fabrics",
    factoryCountry: "Turkey",
    factoryFlag: "🇹🇷",
    category: "Fashion & Silk",
    image: "https://readdy.ai/api/search-image?query=Istanbul%20silk%20scarf%20collection%203pcs%20luxury%20elegant%20colorful%20white%20background%20product%20photography%20premium%20fashion%20Turkey&width=400&height=400&seq=ip12&orientation=squarish",
    retailPrice: 110,
    commissionRate: 25,
    commissionAmount: 27.5,
    warehouseCountries: ["UAE", "UK", "Italy", "France", "USA"],
    totalSold: 2340,
    dropshipping: true,
    verified: true,
  },
];

export const topStars: StarProfile[] = [
  {
    id: "s1",
    name: "Layla Al-Rashid",
    platform: "TikTok",
    platformIcon: "ri-tiktok-fill",
    country: "UAE",
    flag: "🇦🇪",
    followers: "8.2M",
    totalSales: 142800,
    totalCommission: 28560,
    niche: "Luxury & Lifestyle",
    avatar: "https://readdy.ai/api/search-image?query=beautiful%20Arab%20woman%20influencer%20professional%20portrait%20warm%20smile%20confident%20UAE%20lifestyle%20luxury%20content%20creator&width=80&height=80&seq=star1&orientation=squarish",
  },
  {
    id: "s2",
    name: "Marcus Chen",
    platform: "YouTube",
    platformIcon: "ri-youtube-fill",
    country: "USA",
    flag: "🇺🇸",
    followers: "5.4M",
    totalSales: 98400,
    totalCommission: 19680,
    niche: "Tech & Gadgets",
    avatar: "https://readdy.ai/api/search-image?query=Asian%20American%20man%20influencer%20professional%20portrait%20warm%20smile%20confident%20USA%20tech%20YouTube%20content%20creator&width=80&height=80&seq=star2&orientation=squarish",
  },
  {
    id: "s3",
    name: "Sophie Laurent",
    platform: "Facebook",
    platformIcon: "ri-facebook-fill",
    country: "France",
    flag: "🇫🇷",
    followers: "3.1M",
    totalSales: 76200,
    totalCommission: 15240,
    niche: "Fashion & Beauty",
    avatar: "https://readdy.ai/api/search-image?query=French%20woman%20influencer%20professional%20portrait%20warm%20smile%20confident%20France%20fashion%20beauty%20content%20creator&width=80&height=80&seq=star3&orientation=squarish",
  },
  {
    id: "s4",
    name: "Ahmed Khalid",
    platform: "Twitter/X",
    platformIcon: "ri-twitter-x-fill",
    country: "Saudi Arabia",
    flag: "🇸🇦",
    followers: "2.8M",
    totalSales: 54600,
    totalCommission: 10920,
    niche: "Business & Finance",
    avatar: "https://readdy.ai/api/search-image?query=Saudi%20Arab%20man%20influencer%20professional%20portrait%20warm%20smile%20confident%20Saudi%20Arabia%20business%20finance%20content%20creator&width=80&height=80&seq=star4&orientation=squarish",
  },
];
